export default __webpack_public_path__ + "static/media/pool2.de879837.jpg";